/**
 * @generated SignedSource<<831d6110761a36fcfca78aa4de6561ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productSidePanelContent_RemoveAIStagingMutation$variables = {
  productIds: ReadonlyArray<number>;
  ruleId: string;
};
export type productSidePanelContent_RemoveAIStagingMutation$data = {
  readonly removeProductsFromAIStagingRule: {
    readonly result: boolean;
  };
};
export type productSidePanelContent_RemoveAIStagingMutation = {
  response: productSidePanelContent_RemoveAIStagingMutation$data;
  variables: productSidePanelContent_RemoveAIStagingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ruleId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "productIds",
        "variableName": "productIds"
      },
      {
        "kind": "Variable",
        "name": "ruleId",
        "variableName": "ruleId"
      }
    ],
    "concreteType": "ProductAssignmentResult",
    "kind": "LinkedField",
    "name": "removeProductsFromAIStagingRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_RemoveAIStagingMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "productSidePanelContent_RemoveAIStagingMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "0b71f0b541df89121d3d0d7ad14cf36a",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_RemoveAIStagingMutation",
    "operationKind": "mutation",
    "text": "mutation productSidePanelContent_RemoveAIStagingMutation(\n  $ruleId: ID!\n  $productIds: [Long!]!\n) {\n  removeProductsFromAIStagingRule(ruleId: $ruleId, productIds: $productIds) {\n    result\n  }\n}\n"
  }
};
})();

(node as any).hash = "42780a5af0fd4c60f4dc71121b97c330";

export default node;
